module.exports = "/build/images/editButton.svg?bc37052dbe694d46a5eb92fd230eb78e";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/editButton.svg
// module id = 2441
// module chunks = 0